<template>
  <v-card>
    <v-form
      lazy-validation
      ref="form"
      v-model="validForm"
      @submit.prevent="onConfirm"
    >
      <v-card-title primary-title>
        Skapa email mall
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="6">
            <v-text-field
              :rules="[validationRules.required]"
              v-model="model.name"
              label="Mallnamn"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <tiptap-vuetify v-model="model.template" :extensions="extensions" />
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="onClose">
          Avbryt
        </v-btn>
        <v-btn type="submit" color="primary" text>
          Spara
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import { validationRules } from '@/common/validationRules'
import { v4 as uuid } from 'uuid'
import CREATE_MAIL_TEMPLATE from '@/gql/mailTemplates/mutations/CreateMailTemplate.gql'
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
} from 'tiptap-vuetify'

export default {
  name: 'MasterdataEmailTemplatesCreate',

  components: { TiptapVuetify },

  data() {
    return {
      extensions: [
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [1, 2, 3, 4, 5, 6],
            },
          },
        ],
        Bold,
        HorizontalRule,
        Paragraph,
        HardBreak,
      ],
      validationRules,
      validForm: true,
      model: {
        uuid: uuid(),
        name: '',
        template: ``,
      },
    }
  },

  computed: {},

  methods: {
    async onConfirm() {
      const valid = await this.$refs.form.validate()
      if (!valid) return
      this.createMailTemplate()
      this.onClose()
    },

    onClose() {
      this.$emit('close')
    },

    createMailTemplate() {
      return this.$apollo.mutate({
        mutation: CREATE_MAIL_TEMPLATE,
        variables: {
          payload: this.model,
        },
        update: (store, { data }) => {
          this.$store.set('mailTemplates/data', {
            ...this.$store.get('mailTemplates/data'),
            [data.createMailTemplate.uuid]: data.createMailTemplate,
          })
        },
      })
    },
  },
}
</script>
